// extracted by mini-css-extract-plugin
module.exports =  {"volume-control":"O_aN48c","volumeControl":"O_aN48c","on":"DfJcUcm","off":"gNZyZUw"};